import debounce from 'lodash/debounce';
import { StorytellerReduxStore } from '../store/StorytellerReduxStore';
import { windowResized } from '../store/reducers/WindowSizeReducer';

let isInitialized = false;

export function setupWindowSizeListener() {
  if (isInitialized) {
    return;
  }

  const handleResize = debounce(() => {
    StorytellerReduxStore.dispatch(windowResized(window.innerWidth));
  }, 1);

  window.addEventListener('resize', handleResize);

  // Initial dispatch
  StorytellerReduxStore.dispatch(windowResized(window.innerWidth));

  isInitialized = true;
}
